'use client';

import React from 'react';
import { StickyActions } from './sticky-actions';
import { ActionGroup } from './action-group';
import { withDisabledReason } from './disabled-action';

export interface JourneyActionsProps {
  back?: React.ReactNode;
  saveAndExit?: React.ReactNode;
  /** Continue or Submit; existing validation and submission stay with the caller. */
  primary: React.ReactNode;
  disabledReason?: string;
}

export function JourneyActions({
  back,
  saveAndExit,
  primary,
  disabledReason,
}: JourneyActionsProps) {
  return (
    <StickyActions label="Journey actions">
      <ActionGroup
        primary={withDisabledReason(primary, disabledReason)}
        secondary={withDisabledReason([back, saveAndExit], disabledReason)}
      />
    </StickyActions>
  );
}
